import React from 'react';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
type TrustStripProps = {
  className?: string;
  /** 'short' es la tira de 3 ítems bajo un CTA, 'full' agrega pago y formato. */
  variant?: 'short' | 'full';
};
const SHORT = [{
  Icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  Icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  Icon: CreditCardIcon,
  label: 'Tarjeta de crédito'
}];
const FULL = [{
  Icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  Icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  Icon: CreditCardIcon,
  label: 'Stripe · PayPal · Moneda local'
}, {
  Icon: FileTextIcon,
  label: '100% PDF'
}];
export function TrustStrip({
  className = '',
  variant = 'short'
}: TrustStripProps) {
  const items = variant === 'full' ? FULL : SHORT;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-283" data-mp="3urpqxigr5b3a">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-284" data-mp="3muxodrzatxfe">
          <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-285" data-mp="3rsh46wbnai9g" />
          {label}
        </li>)}
    </ul>;
}